import { render, staticRenderFns } from "./BusinessFinanceResultView.vue?vue&type=template&id=f020c4f0&scoped=true&"
import script from "./BusinessFinanceResultView.vue?vue&type=script&lang=js&"
export * from "./BusinessFinanceResultView.vue?vue&type=script&lang=js&"
import style0 from "./BusinessFinanceResultView.vue?vue&type=style&index=0&id=f020c4f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020c4f0",
  null
  
)

export default component.exports